<template>
    <div class="ssid-table">
        <v-checkbox v-model="hasAllSSIDs" label="Todos os SSID'S"></v-checkbox>
        <div v-if="!hasAllSSIDs" class="ssid-table-content">
            <v-data-table
                class="ssid-table-content-body"
                :headers="headers"
                :items="list"
                :loading="loading"
                :hide-actions="true"
                :no-data-text="$t('message.generics.message.noResultsFound')"
                :no-results-text="$t('message.generics.message.noData')"
            >
                <template slot="items" slot-scope="props">
                    <SSIDFIlterItem
                        :item="props.item"
                        :value="value"
                        @change="setSelectedId"
                    />
                </template>
            </v-data-table>
        </div>
    </div>
</template>

<script>
import SSIDFIlterItem from "./SSIDFIlterItem.vue";
import { cloneDeep } from "lodash";

export default {
    components: {
        SSIDFIlterItem,
    },

    data() {
        return {
            page: 0,
            hasAllSSIDs: true,
            list: [],
        };
    },

    computed: {
        headers() {
            return [
                { text: "", value: "", sortable: false, width: 75 },
                {
                    text: this.$t("message.generics.message.name"),
                    value: "name",
                    sortable: false,
                },
            ];
        },
    },

    props: {
        value: {
            type: Array,
        },
        isAllSelected: {
            type: Boolean,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },

    watch: {
        hasAllSSIDs(bool) {
            if (bool) {
                const ssids = this.list.map(({ id }) => id);
                this.$emit("input", ssids);
            }
            this.$emit("update-all-selected", bool);
        },
    },

    methods: {
        setSelectedId(val) {
            let value = cloneDeep(this.value);
            if (val.action === "select") {
                value.push(val.id);
            } else {
                value = value.filter((item) => item !== val.id);
            }
            this.$emit("input", value);
        },

        async getSSIDs() {
            try {
                const response = await this.$api.core.ssid.getAll();
                this.list = response;
            } catch (error) {
                console.log(error);
            }
        },
    },

    mounted() {
        this.getSSIDs();

        this.hasAllSSIDs = this.isAllSelected;
    },
};
</script>

<style lang="scss" scoped>
.ssid-table {
    display: flex;
    flex-direction: column;
}

.ssid-table-content {
    margin: 15px 0;
    width: 100%;

    .ssid-table-content-body {
        padding: 0 20px 10px;
        border: 2px solid #c4c4c4;
        border-radius: 8px;
    }
}
</style>
